module.exports = __webpack_public_path__ + "img/icon_sb_unselect_star_google_t.75c4c06.svg";